import pxToRem from "../../functions/pxToRem";

export default function dialogContent({ typography, borders, colors }) {
  const { size } = typography;
  const { text, grey } = colors;
  const { borderWidth } = borders;

  const dialogContent = {
    styleOverrides: {
      root: {
        padding: `${pxToRem(24)} ${pxToRem(24)} ${pxToRem(16)}`,
        fontSize: size.md,
        color: text.primary,

        // Add spacing between form fields inside dialog
        "& .MuiTextField-root": {
          marginBottom: pxToRem(8),
        },

        "& .MuiFormControl-root": {
          marginBottom: pxToRem(8),
        },
      },

      dividers: {
        borderTop: `${borderWidth[1]} solid ${grey[200]}`,
        borderBottom: `${borderWidth[1]} solid ${grey[200]}`,
      },
    },
  };

  return dialogContent;
}
